var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 200,
    viewBox: "0 0 194 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 61,
    width: 137,
    height: 130,
    fill: "#110E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V200H194V0H0ZM105.575 155.987C105.575 175.453 94.5039 184.307 78.3501 184.307C63.7743 184.307 55.3094 176.52 51.0091 167.133L65.8565 157.867C68.7213 163.04 71.3273 167.467 77.5741 167.467C83.5623 167.467 87.3388 165.113 87.3388 155.667V91.8H105.575V155.987V155.987ZM148.682 184.307C131.752 184.307 120.81 175.987 115.475 165.107L130.316 156.26C134.222 162.78 139.305 167.66 148.294 167.66C155.84 167.66 160.6 163.767 160.6 158.353C160.6 151.913 155.646 149.62 147.317 145.92L142.79 143.853C129.637 138.087 120.914 130.833 120.914 115.52C120.914 101.433 131.286 90.6867 147.608 90.6867C159.196 90.6867 167.525 94.8533 173.527 105.713L159.365 115.08C156.261 109.347 152.859 107.013 147.647 107.013C142.318 107.013 138.904 110.493 138.904 115.08C138.904 120.76 142.267 123 150.091 126.48L154.637 128.547C170.138 135.347 178.868 142.347 178.868 158.08C178.913 175.04 166.025 184.28 148.701 184.28L148.682 184.307Z",
    fill: "#70C5FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.0a5011936d368ca68cfd200c5a4804f9.svg";
export { ForwardRef as ReactComponent };